<template>
  <div>
    <div v-if="!loaded" class="loadingFalse">
      <div class="preloader">
        <span class="preloader-inner">
          <span class="preloader-inner-circle"></span>
        </span>
      </div>
    </div>
    <div v-else>
      <div class="custom-card-header"></div>
      <DxDataGrid
        :data-source="store"
        :show-borders="false"
        :show-column-lines="false"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-column-headers="true"
        :show-colon="false"
        :remote-operations="true"
        :hover-state-enabled="false"
        :show-row-lines="false"
        :row-alternation-enabled="false"
        :no-data-text="$t('noDataTextSummary')"
        class="custom-grid custom-grid-NutritionalFollowing"
        @toolbar-preparing="onToolbarPreparing($event)"
      >
        <DxScrolling mode="standard" />
        <DxStateStoring
          :enabled="false"
          type="localStorage"
          storage-key="nutritionalFollowingTable"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20]"
          :show-info="true"
          info-text="{2} items"
          :visible="true"
        />
        <DxSearchPanel
          :visible="true"
          :width="300"
          :placeholder="$t('search')"
        />
        <DxExport :enabled="false" />
        <DxColumn
          data-field="farm"
          :caption="$t('agronomySample.summary.estate')"
          alignment="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="parcel"
          :caption="$t('agronomySample.summary.parcel')"
          alignment="left"
          :allow-header-filtering="false"
        />

        <DxColumn
          data-field="cultive"
          :caption="$t('agronomySample.cultive')"
          alignment="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="variety"
          :caption="$t('variety')"
          alignment="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          :caption="$t('lastReceipt')"
          alignment="left"
          data-field="sampling_date"
          data-type="date"
          :format="$helpers.getDateFormat(company)"
          :allow-header-filtering="false"
        />

        <DxColumn
          :buttons="editButtons"
          :fixed="true"
          fixed-position="right"
          type="buttons"
          width="80"
        />
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
} from 'devextreme-vue/data-grid';
import { mapState, mapActions } from 'vuex';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'NutritionalFollowingMainTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loaded: true,
      data: [],
      editButtons: [
        {
          icon: iconVisibility,
          onClick: this.viewNutritionalMonitoring,
          cssClass: 'grid-button-icon',
        },
      ],
    };
  },
  computed: {
    ...mapState('contact', ['company']),
  },
  methods: {
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Filtros',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('filter'),
          icon: '././static/icons/ic_filter.svg',
          width: 120,
          height: 40,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    GoNutriVisor() {
      try {
        this.setShowHeader(false);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7router.navigate(
          {
            name: 'Nutrivisor',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      }
    },
    viewNutritionalMonitoring(e) {
      this.setRedirectedFromSamePage(true);
      this.setReportSampleId(e.row.data.sample_id);
      this.setReportSampleCode(e.row.data.code);
      this.setParcelId(e.row.data.parcel_id);
      this.setParcelStr(e.row.data.parcel);
      this.setFarmId(e.row.data.farm_id);
      this.setFarmStr(e.row.data.farm);
      this.setVarietyId(e.row.data.variety_id);
      this.setCultiveId(e.row.data.cultive_id);
      this.setSamplingDateProfile(e.row.data.sampling_date);
      this.setId(e.row.data.id);

      this.$f7router.navigate(
        { name: 'NutritionalMonitoringPage' },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    ...mapActions('samples', [
      'setReportSampleId',
      'setReportSampleCode',
      'getReport',
    ]),
    ...mapActions('nutritionalFollowing', [
      'getNutritionalMonitoringWithoutGeometry',
      'setRedirectedFromSamePage',
    ]),
    ...mapActions('nutritionalMonitoring', [
      'setParcelId',
      'setVarietyId',
      'setCultiveId',
      'setSamplingDateProfile',
      'setId',
    ]),
    ...mapActions('registerFarm', [
      'setParcelStr',
      'setFarmId',
      'setFarmStr',
    ]),
    ...mapActions('PowerBiModules', ['setShowHeader']),
  },
};
</script>

<style>
.custom-grid-NutritionalFollowing .dx-toolbar-before {
  display: grid;
  grid-template-columns: 123px 121px 120px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-NutritionalFollowing .dx-toolbar-before :nth-child(1) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-NutritionalFollowing .dx-toolbar-before :nth-child(2) {
  grid-row: 1;
  grid-column: 3;
}
.custom-grid-NutritionalFollowing .custom-toolbar .dx-toolbar-after {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: repeat(1, 1fr);
  grid-row-gap: 5px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-NutritionalFollowing
  .custom-toolbar
  .dx-toolbar-after
  :nth-child(1) {
  grid-row: 1;
  grid-column: 1;
}
</style>
